/**
 * Create a new object by a mapping function that accepts the values in the object
 */
export default function objectMap<T, T2>(o: { [key: string]: T }, f: (t: T, key: string) => T2) {
  const onew: { [key: string]: T2 } = {};
  for (const key in o) {
    onew[key] = f(o[key], key);
  }
  return onew;
}

export function objectMapToSameObjectType<T extends Object>(o: T, f: (t: any, key: keyof T) => any) {
  const onew: T = {} as T;
  for (const key in o) {
    onew[key] = f(o[key], key) as any;
  }
  return onew;
}
